/* eslint-disable no-underscore-dangle */

export const RECAPTCHA_ERROR_MESSAGE =
  'There was an error submitting your donation. Please try again. If the issue persists, contact membership@wacobridge.org.';

export const STRIPE_KEY = window.__STRIPE_KEY__;

export const RECAPTCHA_KEY = window.__RECAPTCHA_KEY__;

// export const NEWSROOM = window.__NEWSROOM__;
